/* global angular, moment */

/**
 * Created by lari on 08/06/2017.
 */

(function () {
  'use strict';
  angular.module('vcutils.doctor')
    .component('doctornew', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="doctornew-component" data-hook="doctornew-component">
        <h3>Neuen Arzt anlegen</h3>
        <div class="btn btn-success" ng-click="vm.addDoctor()" ng-hide="vm.newdoctor">Neuen Arzt anlegen</div>
        <div ng-show="vm.newdoctor">
          <doctorform doctor="vm.newdoctor" parentsave="vm.saveNewDoctor(doctor)" oncancel="vm.cancel()"></doctorform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Arzt erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen eines neuen Arztes wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Arzt konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Doctor', 'Rlog',
        function ($log, Doctor, Rlog) {
          let vm = this;
          vm.addDoctor = addDoctor;
          vm.saveNewDoctor = saveNewDoctor;
          vm.cancel = cancel;
          
          function addDoctor() {
            vm.newdoctor = {};
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewDoctor(doctor) {
            $log.debug('debug: create new doctor: ', doctor);
            delete vm.newdoctor;
            Doctor.$create(doctor).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new doctor failed: ', err);
              Rlog.error('vcutils.doctor', 'doctornew', 'Creation of new doctor failed: ', {error: err, doctor: vm.newdoctor});
            });
          }
          
          function cancel() {
            delete vm.newdoctor;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());